exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-all-projects-js": () => import("./../../../src/pages/all-projects.js" /* webpackChunkName: "component---src-pages-all-projects-js" */),
  "component---src-pages-archieve-js": () => import("./../../../src/pages/archieve.js" /* webpackChunkName: "component---src-pages-archieve-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

